import { Component, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, ViewChild, ViewContainerRef, EmbeddedViewRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';

import { Translations } from './header.translation';
import { HeaderService } from '../../services/header/header.service';
import { ProfileService } from '../../services/profile/profile.service';

import { UiComponent } from '../ui/ui.component';

import { ConfigService } from '../../services/config/config.service';
import { MessageService } from '../../services/message/message.service';

import { Links } from './sidebarTop';

declare const $: any;

@Component({
  selector: 'header',
  template: `
    <ul id="slide-out" class="side-nav custom-scrollbar">
      <li [routerLink]="['/users/' + sessionService.currentSession.users.id]" class="user-card pointer waves-effect">
        <div class="logo-wrapper sn-ad-avatar-wrapper">
          <i class="fa fa-user-circle fa-2x user-logo"></i>
          <div class="user">
            <div class="ellipsis">{{sessionService.currentSession.users.firstname | capitalize}} {{sessionService.currentSession.users.lastname | uppercase}}</div>
            <div class="ellipsis">{{sessionService.currentSession.users.email}}</div>
          </div>
        </div>
      </li>
      <li class="sidebarleft">
        <ul *ngIf="!loading" class="collapsible collapsible-accordion">
          <li *ngFor="let menu of profileService.profile.details">
            <a *ngIf="menu.links == null" (click)="clickLink(menu)" class="waves-effect">
              <i class="{{menu.glyph}}"></i>{{menu.caption}}
              <span *ngIf="menu.new" class="badge red">New</span>
              <span *ngIf="menu.updated" class="badge indigo">Updated</span>
            </a>
            <a *ngIf="menu.links != null" class="collapsible-header waves-effect arrow-r">
              <i class="{{menu.glyph}}"></i> {{menu.caption}}
              <i class="fa fa-angle-down rotate-icon"></i>
              <span *ngIf="menu.new" class="badge red">New</span>
              <span *ngIf="menu.updated" class="badge indigo">Updated</span>
            </a>
            <div *ngIf="menu.links != null" class="collapsible-body">
              <ul>
                <li *ngFor="let submenu of menu.links">
                  <a (click)="clickLink(submenu)" class="waves-effect">
                    <i class="{{submenu.glyph}}"></i>{{submenu.caption}}
                    <span *ngIf="submenu.new" class="badge red">New</span>
                    <span *ngIf="submenu.updated" class="badge indigo">Updated</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </li>
      <li class="row fixed-bottom m-0">
        <h5 class="col-12 mb-0">Profiles</h5>
        <a *ngFor="let profile of profileService.profiles" (click)="profileService.setProfile(profile)" class="profile col-2 p-0"
          data-toggle="tooltip" [title]="profile.caption">
          <i class="{{profile.glyph}}"></i>
        </a>
      </li>
    </ul>
    <nav *ngIf="sessionService.isLoggedIn()" class="navbar navbar-toggleable-md scrolling-navbar double-nav" style="background-color: #007bff;">
      <div class="pull-left">
        <a href="#" data-activates="slide-out" class="button-collapse">
          <i class="fa fa-bars fa-lg"></i>
        </a>
      </div>
      <ul class="nav navbar-nav">
        <ng-container #breadcrumb></ng-container>
      </ul>
      <ul class="nav navbar-nav nav-flex-icons ml-auto">
        <li *ngFor="let menu of sidebarTop" class="nav-item" [ngClass]="{'dropdown':menu.links != null}">
          <a *ngIf="menu.links == null" class="nav-link" (click)="clickLink(menu)" data-toggle="tooltip" title="{{ 'ui.' + menu.caption }}">
            <i class="{{menu.glyph}} fa-lg"></i>
          </a>
          <a *ngIf="menu.links != null" class="nav-link dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false" data-toggle="tooltip" title="{{ 'ui.' + menu.caption }}">
            <i class="{{menu.glyph}} fa-lg"></i>
          </a>
          <div *ngIf="menu.links != null" class="dropdown-menu dropdown-primary dd-right" aria-labelledby="dropdownMenu1" data-dropdown-in="fadeIn"
            data-dropdown-out="fadeOut">
            <a *ngFor="let submenu of menu.links" (click)="clickLink(submenu)" class="dropdown-item" data-toggle="tooltip" title="{{ 'ui.' + submenu.caption }}">
              <i class="{{submenu.glyph}}"></i>
            </a>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="sessionService.logout()" data-toggle="tooltip" title="{{ ui.logout }}">
            <i class="fa fa-sign-out fa-lg"></i>
          </a>
        </li>
      </ul>
    </nav>
  `,
  styles: [`
    .navbar-nav .nav-link {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }
    .navbar {
        box-shadow: none;
    }
    .navbar {
        border-radius: 0px;
    }
    .navbar-brand {
        font-size: 1rem;
    }
    .pref-link {
        position: absolute;
        top: -10px;
        right: 10px;
        width: auto;
    }
    .sidebarleft {
        overflow: auto;
        height: calc(100% - 10rem);
    }
    .side-nav .sn-ad-avatar-wrapper p {
        padding-top: 11px !important;
        padding-bottom: 11px !important;
    }
    .user {
        padding: .6rem 0 !important;
    }
    .user-card {
        border-bottom: 2px solid white !important;
    }
    .user-logo {
        float: left !important;
        margin: 1.1rem 1rem !important;
    }
    .ellipsis {
        text-overflow: ellipsis !important;
        overflow: hidden !important;
    }
    .profile {
        text-align: center;
        height: 30px;
        line-height: 30px;
    }
  `]
})

//@Injectable()
export class HeaderComponent extends UiComponent {

  public sidebarTop: any[] = (<any>Links);
  public menuListSearch: any = new Array<any>();
  public title: string = 'Odusseus';
  public loggedIn: boolean = false;
  public loading: boolean = false;
  public profilChanged: boolean = false;
  public modalId: number;
  public listFilter: string = '';
  _current: EmbeddedViewRef<any> | null = null;
  @ViewChild('breadcrumb', { read: ViewContainerRef }) breadcrumb: ViewContainerRef;

  constructor(injector: Injector, public service: HeaderService, public profileService: ProfileService) {
    super(injector);
    this.name = 'header';
    this.setTranslations(Translations);
  }

  ngAfterViewInit(): void {
    this
      .service
      .contents
      .subscribe(ref => {
        if (this._current !== null) {
          this._current.destroy();
          this._current = null;
        }
        if (ref === null) {
          return;
        }
        this._current = this.breadcrumb.createEmbeddedView(ref);
      });
  }

  filterChange(filter: string) {
  }

  onLoadLanguage(): void {
    const route: string = 'language-list';
    this.router.navigate(['/' + route]);
  }

  clickLink(item: any) {
    this.router.navigate(['/' + item.link]);
  }

  openPreferences() {
    let parameters;
    parameters = {
      modal: true,
      header: this
    };
  }
}
